export default __webpack_public_path__ + "static/media/greenline-capital.fd3d28ab.png";